export default {
  // api请求地址
  API_URL: 'https://opwf-backend.ushow.media',
  HUIDU_API_URL: 'https://opwf-backend-huidu.ushow.media',
  // API_URL: 'http://192.168.13.132:8002',
  UPLOAD_URL: 'https://opwf-backend.ushow.media',
  SLOW_API_URI: 'https://devops.ushow.media',
  webSocket_API: 'https://devops.ushow.media',
}



// WEBPACK FOOTER //
// ./config/urls.js